import {
  fa0,
  faAbacus,
  faAddressBook,
  faAddressCard,
  faAmpersand,
  faAnchor,
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faArchive,
  faArchway,
  faArrowAltCircleDown,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faArrowAltCircleUp,
  faArrowDown,
  faArrowDownLeft,
  faArrowFromBottom,
  faArrowFromTop,
  faArrowLeft,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faArrowProgress,
  faArrowUpRight,
  faArrowUpToLine,
  faArrowsAlt,
  faArrowsLeftRight,
  faArrowsToCircle,
  faArrowsUpDownLeftRight,
  faArrowsV,
  faArrowToBottom,
  faArrowToLeft,
  faArrowToRight,
  faArrowTurnDownLeft,
  faArrowUp,
  faAsterisk,
  faAt,
  faBadgeCheck,
  faBadgePercent,
  faBallotCheck,
  faBars,
  faBell,
  faBoxBallot,
  faBracketsCurly,
  faBrainCircuit,
  faBriefcase,
  faBrowser,
  faBullhorn,
  faBullseyePointer,
  faCalculatorSimple,
  faCalendarAlt,
  faCalendarExclamation,
  faCaretDown,
  faCaretUp,
  faCashRegister,
  faChalkboardTeacher,
  faChartBar,
  faChartNetwork,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCheckSquare,
  faCheckToSlot,
  faChevronCircleDown,
  faChevronCircleUp,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronsDown,
  faChevronsLeft,
  faChevronsRight,
  faChevronsUp,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faCirclePlay,
  faCircleTrash,
  faCircleUser,
  faCircleX,
  faClipboardCheck,
  faClock,
  faClone,
  faCloudUpload,
  faCode,
  faCog,
  faCogs,
  faComment,
  faCommentAltLines,
  faCommentExclamation,
  faConstruction,
  faCopy,
  faCreditCard,
  faDatabase,
  faDirections,
  faDisplay,
  faDotCircle,
  faDownload,
  faDownToLine,
  faEllipsisV,
  faEnvelope,
  faEraser,
  faExchange,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileChartLine,
  faFileChartPie,
  faFileCheck,
  faFileCode,
  faFileContract,
  faFileDownload,
  faFileExcel,
  faFileExport,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFileJpg,
  faFileMedical,
  faFilePdf,
  faFilePowerpoint,
  faFileSearch,
  faFileTimes,
  faFileUpload,
  faFileUser,
  faFileWord,
  faFileZipper,
  faFilter,
  faFlag,
  faFolderGear,
  faFolderOpen,
  faFolderPlus,
  faFolders,
  faFolderUser,
  faGearCode,
  faGlobe,
  faGripLinesVertical,
  faHandFist,
  faHandHoldingSeedling,
  faHandHoldingStar,
  faHandPointer,
  faHandPointRight,
  faHandshake,
  faHeadSide,
  faHighlighterLine,
  faHistory,
  faHourglassEnd,
  faHourglassHalf,
  faHourglassStart,
  faHouse,
  faICursor,
  faInboxIn,
  faIndustryAlt,
  faInfinity,
  faInfoCircle,
  faInfoSquare,
  faInputText,
  faJedi,
  faKey,
  faLayerPlus,
  faLink,
  faLinkHorizontal,
  faLinkHorizontalSlash,
  faList,
  faListCheck,
  faListUl,
  faLocationCrosshairs,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faMailBulk,
  faMapMarkerAlt,
  faMapMarkerQuestion,
  faMemoCircleCheck,
  faMerge,
  faMessageSlash,
  faMicrochipAi,
  faMinus,
  faNetworkWired,
  faNotEqual,
  faObjectIntersect,
  faOctagonXmark,
  faPage,
  faPageBreak,
  faPaperPlane,
  faPaste,
  faPen,
  faPenField,
  faPenPaintbrush,
  faPercent,
  faPhoneSquare,
  faPiggyBank,
  faPipe,
  faPlay,
  faPlus,
  faPlusCircle,
  faPlusMinus,
  faPollH,
  faPollPeople,
  faQuestion,
  faQuestionCircle,
  faQuestionSquare,
  faRedo,
  faRulerHorizontal,
  faSave,
  faScalpelPath,
  faScrewdriverWrench,
  faSearch,
  faSearchLocation,
  faServer,
  faShare,
  faShieldCheck,
  faShieldExclamation,
  faShuffle,
  faSigma,
  faSignsPost,
  faSlashForward,
  faSortAmountDown,
  faSortAmountDownAlt,
  faSortAmountUp,
  faSortDown,
  faSparkles,
  faSpellCheck,
  faSpinner,
  faSquare,
  faSquareDashed,
  faSquarePen,
  faSquarePlus,
  faStarOfLife,
  faStopwatch,
  faSuitcase,
  faSyncAlt,
  faTable,
  faTachometerFast,
  faTachometerSlow,
  faTachometerSlowest,
  faTag,
  faTags,
  faTasks,
  faText,
  faTextSize,
  faTh,
  faThLarge,
  faThumbsUp,
  faTimer,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashCanPlus,
  faTrashCheck,
  faTreeChristmas,
  faTriangleExclamation,
  faTurnUp,
  faUndo,
  faUndoAlt,
  faUniversity,
  faUnlink,
  faUpFromLine,
  faUpload,
  faUpRightFromSquare,
  faUser,
  faUserAlien,
  faUserCheck,
  faUserChef,
  faUserClock,
  faUserCog,
  faUserEdit,
  faUserGear,
  faUserHardHat,
  faUserHelmetSafety,
  faUserLock,
  faUserRobot,
  faUsersLine,
  faUserTie,
  faUserTimes,
  faValueAbsolute,
  faWaveform,
  faWaveformLines,
  faWrench,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';

import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

export const icons = [
  fa0,
  faAbacus,
  faAddressBook,
  faAddressCard,
  faAmpersand,
  faAnchor,
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faArchive,
  faArchway,
  faArrowAltCircleDown,
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faArrowAltCircleUp,
  faArrowFromBottom,
  faArrowDown,
  faArrowDownLeft,
  faArrowFromTop,
  faArrowLeft,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faArrowProgress,
  faArrowUpRight,
  faArrowUpToLine,
  faArrowsAlt,
  faArrowsLeftRight,
  faArrowsToCircle,
  faArrowsUpDownLeftRight,
  faArrowsV,
  faArrowToBottom,
  faArrowToLeft,
  faArrowToRight,
  faArrowTurnDownLeft,
  faArrowUp,
  faAsterisk,
  faAt,
  faBadgeCheck,
  faBadgePercent,
  faBallotCheck,
  faBars,
  faBell,
  faBoxBallot,
  faBracketsCurly,
  faBrainCircuit,
  faBriefcase,
  faBrowser,
  faBullhorn,
  faBullseyePointer,
  faCalculatorSimple,
  faCalendarAlt,
  faCalendarExclamation,
  faCaretDown,
  faCaretUp,
  faCashRegister,
  faChalkboardTeacher,
  faChartBar,
  faChartNetwork,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCheckSquare,
  faCheckToSlot,
  faChevronCircleDown,
  faChevronCircleUp,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronsDown,
  faChevronsLeft,
  faChevronsRight,
  faChevronsUp,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faCirclePlay,
  faCircleTrash,
  faCircleUser,
  faCircleX,
  faClipboardCheck,
  faClock,
  faClone,
  faCloudUpload,
  faCode,
  faCog,
  faCogs,
  faComment,
  faCommentAltLines,
  faCommentExclamation,
  faConstruction,
  faCopy,
  faCreditCard,
  faDatabase,
  faDirections,
  faDisplay,
  faDotCircle,
  faDownload,
  faDownToLine,
  faEllipsisV,
  faEnvelope,
  faEraser,
  faExchange,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileChartLine,
  faFileChartPie,
  faFileCheck,
  faFileCode,
  faFileContract,
  faFileDownload,
  faFileExcel,
  faFileExport,
  faFileImage,
  faFileImport,
  faFileInvoice,
  faFileJpg,
  faFileMedical,
  faFilePdf,
  faFilePowerpoint,
  faFileSearch,
  faFileTimes,
  faFileUpload,
  faFileUser,
  faFileWord,
  faFileZipper,
  faFilter,
  faFlag,
  faFolderGear,
  faFolderOpen,
  faFolderPlus,
  faFolders,
  faFolderUser,
  faGearCode,
  faGlobe,
  faGripLinesVertical,
  faHandFist,
  faHandHoldingSeedling,
  faHandHoldingStar,
  faHandPointer,
  faHandPointRight,
  faHandshake,
  faHeadSide,
  faHighlighterLine,
  faHistory,
  faHourglassEnd,
  faHourglassHalf,
  faHourglassStart,
  faHouse,
  faICursor,
  faInboxIn,
  faIndustryAlt,
  faInfinity,
  faInfoCircle,
  faInfoSquare,
  faInputText,
  faJedi,
  faKey,
  faLayerPlus,
  faLink,
  faLinkHorizontal,
  faLinkHorizontalSlash,
  faList,
  faListCheck,
  faListUl,
  faLocationCrosshairs,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faMailBulk,
  faMapMarkerAlt,
  faMapMarkerQuestion,
  faMemoCircleCheck,
  faMerge,
  faMessageSlash,
  faMicrochipAi,
  faMinus,
  faNetworkWired,
  faNotEqual,
  faObjectIntersect,
  faOctagonXmark,
  faPage,
  faPageBreak,
  faPaperPlane,
  faPaste,
  faPen,
  faPenField,
  faPenPaintbrush,
  faPercent,
  faPhoneSquare,
  faPiggyBank,
  faPipe,
  faPlay,
  faPlus,
  faPlusCircle,
  faPlusMinus,
  faPollH,
  faPollPeople,
  faQuestion,
  faQuestionCircle,
  faQuestionSquare,
  faRedo,
  faRulerHorizontal,
  faSave,
  faScalpelPath,
  faScrewdriverWrench,
  faSearch,
  faSearchLocation,
  faServer,
  faShare,
  faShieldCheck,
  faShieldExclamation,
  faShuffle,
  faSigma,
  faSignsPost,
  faSlashForward,
  faSortAmountDown,
  faSortAmountDownAlt,
  faSortAmountUp,
  faSortDown,
  faSparkles,
  faSpellCheck,
  faSpinner,
  faSpinnerThird,
  faSquare,
  faSquareDashed,
  faSquarePen,
  faSquarePlus,
  faStarOfLife,
  faStopwatch,
  faSuitcase,
  faSyncAlt,
  faTable,
  faTachometerFast,
  faTachometerSlow,
  faTachometerSlowest,
  faTag,
  faTags,
  faTasks,
  faText,
  faTextSize,
  faTh,
  faThLarge,
  faThumbsUp,
  faTimer,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashCanPlus,
  faTrashCheck,
  faTreeChristmas,
  faTriangleExclamation,
  faTurnUp,
  faUndo,
  faUndoAlt,
  faUniversity,
  faUnlink,
  faUpFromLine,
  faUpload,
  faUpRightFromSquare,
  faUser,
  faUserAlien,
  faUserCheck,
  faUserChef,
  faUserClock,
  faUserCog,
  faUserEdit,
  faUserGear,
  faUserHardHat,
  faUserHelmetSafety,
  faUserLock,
  faUserRobot,
  faUsersLine,
  faUserTie,
  faUserTimes,
  faValueAbsolute,
  faWaveform,
  faWaveformLines,
  faWrench,
  faXmark,
];
